export const applicanttrackingjobcategoriesdata = [
  {
    name: "Software Engineer",
    description:
      "Responsible for developing and maintaining software applications.",
    status: "Active",
    date_created: "2023-01-15",
  },
  {
    name: "Product Manager",
    description:
      "Leads the product development process, from concept to launch.",
    status: "Inactive",
    date_created: "2022-11-10",
  },
  {
    name: "Data Scientist",
    description:
      "Uses statistical methods and machine learning to analyze and interpret complex data.",
    status: "Active",
    date_created: "2023-03-01",
  },
  {
    name: "Marketing Specialist",
    description:
      "Responsible for developing and executing marketing strategies to drive brand awareness.",
    status: "Active",
    date_created: "2023-05-20",
  },
  {
    name: "HR Manager",
    description:
      "Oversees recruiting, employee relations, and performance management.",
    status: "Inactive",
    date_created: "2021-08-15",
  },
  {
    name: "Graphic Designer",
    description:
      "Designs visual content for branding, advertisements, and digital media.",
    status: "Active",
    date_created: "2023-06-10",
  },
  {
    name: "System Administrator",
    description: "Manages and maintains IT infrastructure and systems.",
    status: "Active",
    date_created: "2022-12-05",
  },
  {
    name: "Business Analyst",
    description:
      "Analyzes business processes and data to provide insights and recommendations.",
    status: "Active",
    date_created: "2023-01-25",
  },
  {
    name: "Sales Manager",
    description:
      "Leads and manages a team of sales professionals to achieve revenue goals.",
    status: "Active",
    date_created: "2022-07-18",
  },
  {
    name: "Content Writer",
    description:
      "Creates written content for websites, blogs, and marketing materials.",
    status: "Inactive",
    date_created: "2021-09-01",
  },
  {
    name: "Accountant",
    description:
      "Manages financial records, prepares reports, and ensures compliance with tax laws.",
    status: "Active",
    date_created: "2023-02-20",
  },
  {
    name: "Project Manager",
    description: "Plans, organizes, and manages projects from start to finish.",
    status: "Active",
    date_created: "2022-11-25",
  },
  {
    name: "UX/UI Designer",
    description:
      "Designs user interfaces and user experiences for web and mobile applications.",
    status: "Active",
    date_created: "2023-04-15",
  },
  {
    name: "Customer Support Representative",
    description:
      "Provides assistance and solutions to customers via phone, email, or chat.",
    status: "Active",
    date_created: "2023-07-02",
  },
  {
    name: "Legal Counsel",
    description:
      "Advises on legal matters, drafts contracts, and ensures compliance with regulations.",
    status: "Inactive",
    date_created: "2021-06-30",
  },
  {
    name: "Network Engineer",
    description:
      "Designs, implements, and maintains computer networks for organizations.",
    status: "Active",
    date_created: "2022-10-22",
  },
  {
    name: "Quality Assurance Tester",
    description:
      "Tests software to ensure it meets required standards and is free of defects.",
    status: "Active",
    date_created: "2023-03-12",
  },
  {
    name: "Operations Manager",
    description:
      "Oversees day-to-day operations, ensuring efficiency and effectiveness in processes.",
    status: "Active",
    date_created: "2022-09-14",
  },
  {
    name: "Financial Analyst",
    description:
      "Analyzes financial data to guide investment and business decisions.",
    status: "Inactive",
    date_created: "2021-12-10",
  },
  {
    name: "Public Relations Manager",
    description:
      "Manages the public image of the company and builds relationships with the media.",
    status: "Active",
    date_created: "2023-02-28",
  },
  {
    name: "Supply Chain Manager",
    description:
      "Manages and optimizes the flow of goods and services within the supply chain.",
    status: "Inactive",
    date_created: "2022-08-05",
  },
  {
    name: "IT Support Specialist",
    description:
      "Provides technical support and troubleshooting for hardware and software issues.",
    status: "Active",
    date_created: "2023-05-10",
  },
  {
    name: "Social Media Manager",
    description:
      "Manages a company's social media platforms and content strategy.",
    status: "Active",
    date_created: "2023-01-18",
  },
];
